export const GET_WIDGETS_SUCCESS = "GET_WIDGETS_SUCCESS";
